export default {
    rm_nav_title: "還款方式",
    rm_allow_repayment_online: "銀行帳戶支付",
    rm_allow_repayment_online_p: "支援網路銀行、櫃檯、Viettel門市支付",
    rm_allow_repayment_online_p2: "即還即藉，無需等待",
    rm_allow_recommend: "推薦",
    rm_allow_transfer_bank: "銀行卡轉帳",
    rm_allow_transfer_bank_p: "轉帳公司銀行帳戶",
    rm_allow_repayment_offline: "線下支付",
    rm_allow_repayment_offline_p: "Viettel Post線下還款碼支付",
    bank_virtual_card_information: "虛擬卡資訊",
    bank_bank: "銀行",
    bank_branch_bank: "支行",
    bank_bank_account_name: "帳戶名稱",
    bank_account: "帳戶",
    bank_repay_sum: "還款金額",
    bank_repay_msg: "還款說明",
    bank_pay_immediately: "立即還款",
    bank_repay_msg1: "1.您可以選擇網路銀行、櫃檯、Viettel門市等方式進行付款操作。",
    bank_repay_msg2: "2.進行還款操作時請確認輸入完整的銀行帳戶，如帳戶中有字母也務必完整輸入，字母也是帳戶的一部分。輸入不完整的帳戶將會導致銀行您的資金損失或被銀行 拒絕交易。",
    bank_repay_msg3: "3.由於銀行系統原因，「普通轉帳」並不能保證資金及時到達我們帳戶，我們只能以銀行實際入帳時間來判斷您的實際存款並進行清算。",
    bank_copy_msg: "已經複製到剪切板",
    bank_copy_suc: "複製成功",
    bank_copy_err: "複製失敗",
    bank_funpay_code: "Funpay還款碼",
    bank_funpay_msg: "還款說明",
    bank_funpay_msg1: "1.請尋找離您最近的Viettel Post。",
    bank_funpay_msg1_address: "查看位址",
    bank_funpay_msg2: "2.告訴Viettel Post店員您需要使用FunPay進行支付，並展示FunPay的LOGO給到店員。",
    bank_funpay_msg3: "3.將支付碼告知店員。",
    bank_funpay_msg4: "4.店員會簡單與您核對下您的姓名與電話。",
    bank_funpay_msg5: "5.支付對應的金額，即可完成交易。",
    bank_com_pay_msg1: "1.您可以選擇網路銀行、櫃檯、Viettel門市等方式進行付款操作。",
    bank_com_pay_msg2: "2.進行還款操作時請確認輸入完整的銀行帳戶，如帳戶中有字母也務必完整輸入，字母也是帳戶的一部分。輸入不完整的帳戶將會導致銀行您的資金損失或被銀行 拒絕交易。",
    bank_com_pay_msg3: "3.由於銀行系統原因，「普通轉帳」並不能保證資金及時到達我們帳戶，我們只能以銀行實際入帳時間來判斷您的實際存款並進行清算。",
    bank_remark: "備註內容",
    bank_allowTransferBank_tips: "*註：轉帳時請複製您申請貸款的姓名和手機號，用於轉帳備註。",
    bank_companyPay_wrapper_title: "溫馨提醒",
    bank_companyPay_wrapper_tips_1: "使用該還款方式，需等待工作人員平帳。",
    bank_companyPay_wrapper_tips_2: "推薦您使用銀行帳戶支付，即還即藉。",
    bank_companyPay_wrapper_btn_1: "使用銀行帳戶付款",
    bank_companyPay_wrapper_btn_2: "使用銀行卡轉帳",
}